import React, { useState, useReducer, useRef, useEffect } from 'react';
import {Row, Col, Empty, Button, Drawer, List, Popconfirm} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faShoppingBasket, faBoxAlt, faBoxCheck, faTrash, faMinus, faMinusCircle} from "@fortawesome/pro-duotone-svg-icons";
import { AddItem } from './AddItem';
//import { reducerPedido , defaultState, reducerPedidoTypes} from '../../../store/reducer-pedido';
import { Estoque, Dinheiro } from '..';
//import { ReducerProdutos, defaultStateProdutos, reducerProdutosTypes } from '../../../store/reducer-produtos';
import { useAxios } from '../../hooks';
import { usePedido } from '../../services/usePedidos';
import { useSelector, useDispatch } from 'react-redux'; 

const useProdutos = (/* dispatchProdutos */) => {
    const {getApiEmitirNotas} = useAxios();
    let produtosArr = [];

    const produtos = useSelector((state) => state.reducerProdutos);
    const dispatch = useDispatch();

    const listaProdutos = async () => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/produtos/filtro?termo=');
        produtosArr = result.data;
        //dispatchProdutos({type: reducerProdutosTypes.SET_PRODUTOS, payload: produtosArr})
        var key = 1;
       produtosArr.forEach((element,index) => {
            element.key = ++key;
            produtosArr[index] = element;
        });
        dispatch({type: produtos.reducerProdutosTypes.SET_PRODUTOS, payload: produtosArr})
        console.log("produtos",produtos);
       // dispatch({type: 'BUSCAR_PRODUTOS', payload: produtosArr})
    }

    return {listaProdutos}
}


const Itens = (/* {reducer} */) => {

    const [addItemVisivel, setAddItemVisivel] = useState(false);
    //const [stateProdutos, dispatchProdutos]  = useReducer(ReducerProdutos, defaultStateProdutos);
    const {listaProdutos} = useProdutos(/* dispatchProdutos */);
    const produtos = useSelector((state) => state.reducerProdutos);
    const {removerItemDb} = usePedido();
    
    // const {pedido} = props;
    //const {state, dispatch} = reducer;
    //const {pedido} = state;
    const reducerPedido = useSelector((state)=>state.reducerPedido);
    const pedido = reducerPedido.pedido;
    const dispatch = useDispatch();
    useEffect(() => {
        listaProdutos();
    },[dispatch]) 


    const toogleFormularioItem = () =>{
        setAddItemVisivel(true);
    }

    const close = ()=>{
        setAddItemVisivel(false);
    }

    const drawer = () => {
        return <AddItem visible={addItemVisivel} close={close} /* reducer={reducer} */ /* reducerProdutos={{stateProdutos, dispatchProdutos}} */ />;
    }

    const btnInserirProduto = () => ( <Button type="primary" disabled={pedido.estoque == "SEPARADO"} onClick={toogleFormularioItem} >Inserir Produto</Button>)

    
    
    if(pedido.itens && pedido.itens.length){
        var key=1;
        return <>
            <List
                
                style={{textAlign: 'left'}}
                itemLayout="horizontal"
                dataSource={pedido.itens}
                
                renderItem={ item => {
                    
                    let removing = false;

                    const removerItem = async () => {
                        removing = true;
                        const novoPedido = await removerItemDb(pedido, item);
                        removing = false;
                        dispatch({type: reducerPedido.reducerPedidoTypes.SET_PEDIDO, payload: novoPedido});
                    }


                    return (
                    <List.Item  key={++key} >
                        <List.Item.Meta
                            avatar={<FontAwesomeIcon size="2x" icon={faBoxCheck}></FontAwesomeIcon>}
                            title={item.descricaoProduto}
                            description={<>
                                Cód: {item.codigoProduto} | 
                                <Estoque value={item.quantidade} unidade={item.unidade} />x<Dinheiro value={item.valorUn} /> | Desc: <Dinheiro value={item.totalDescontos}></Dinheiro></>}
                        ></List.Item.Meta>
                        <div>
                            <Dinheiro value={item.totalItem}></Dinheiro>
                        </div>

                        {(() => {
                            if(item.processamentoEstoque == "NAO_PROCESSADO"){
                                return (
                                    <div style={{display: "block"}}>
                                        <Popconfirm placement="topLeft" title="Tem Certeza?" onConfirm={removerItem} okText="Sim" cancelText="Não">
                                            <Button type="text" loading={removing} style={{color: "red"}}><FontAwesomeIcon icon={faMinusCircle} ></FontAwesomeIcon></Button>
                                            
                                        </Popconfirm>
                                    </div>
                                );
                            }
                        })()}
                    </List.Item>
                )}}
                rowKey={(x)=>{return x.id+(key++)}}></List>
            {btnInserirProduto()}
            {drawer()}
        </>
    } 

    
    

    return <>
        <Row>
            <Col span={24} style={{textAlign: 'center'}}>
                <Empty description="Nenhum produto adicionado. Insira seu primeiro!" image={<FontAwesomeIcon size="5x" icon={faShoppingBasket}></FontAwesomeIcon>} >
                    {btnInserirProduto()}
                </Empty>
            </Col>
        </Row>
        {drawer()}

    </>;

}

export {Itens};